export default "__VITE_ASSET__b436d560__"